import React from 'react';
import HeroSection from '../../components/hero/HeroSection';
import WhyChooseSection from '../../components/why-choose/WhyChooseSection';
import FeaturesSection from '../../components/features/FeaturesSection';
import HowItWorksSection from '../../components/how-it-works/HowItWorksSection';
import TestimonialSection from '../../components/testimonials/TestimonialSection';
import CtaSection from '../../components/cta/CtaSection';

const Home = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <WhyChooseSection />
      <FeaturesSection />
      <HowItWorksSection />
      <TestimonialSection />
      <CtaSection />
    </div>
  );
}

export default Home;
